import { render } from "./TheTransactionList.vue?vue&type=template&id=06132f58&ts=true"
import script from "./TheTransactionList.vue?vue&type=script&lang=ts"
export * from "./TheTransactionList.vue?vue&type=script&lang=ts"

import "./TheTransactionList.vue?vue&type=style&index=0&id=06132f58&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__